import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 51138 51138"
    {...props}
  >
    <defs>
      <style>
        {".str0{stroke:#2b2a29;stroke-width:741.137}.fil0{fill:#2b2a29}"}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2283705130208">
        <path
          d="M33323 371c-1071 0-1939 867-1939 1938s868 1938 1939 1938h2584c6067 0 10984 4918 10984 10984v2584c0 1071 868 1939 1939 1939 1070 0 1938-868 1938-1939v-2584c0-8207-6653-14860-14861-14860h-2584zM15231 371C7024 371 371 7024 371 15231v2584c0 1071 867 1939 1938 1939s1938-868 1938-1939v-2584c0-6066 4918-10984 10984-10984h2584c1071 0 1939-867 1939-1938s-868-1938-1939-1938h-2584zM25569 13293c-6780 0-12276 5496-12276 12276s5496 12276 12276 12276 12276-5496 12276-12276-5496-12276-12276-12276zM4247 33323c0-1071-867-1939-1938-1939s-1938 868-1938 1939v2584c0 8208 6653 14861 14860 14861h2585c1070 0 1938-868 1938-1938 0-1071-868-1939-1938-1939h-2585c-6066 0-10984-4917-10984-10984v-2584zM50768 33323c0-1071-868-1939-1938-1939-1071 0-1939 868-1939 1939v2584c0 6067-4917 10984-10984 10984h-2584c-1071 0-1939 868-1939 1939 0 1070 868 1938 1939 1938h2584c8208 0 14861-6653 14861-14861v-2584z"
          className="fill stroke1"
          style={{
            strokeWidth: 741.137,
          }}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
